// HESHAURA categories — bracelet-only catalogue. Live list comes from
// GET /api/categories; these are fallback labels + collection copy.

export const CATEGORIES = [
  { id: "everyday", label: "Everyday Bracelets" },
  { id: "minimal", label: "Minimal Bracelets" },
  { id: "charm", label: "Charm Bracelets" },
  { id: "statement", label: "Statement Bracelets" },
  { id: "tennis", label: "Tennis Bracelets" },
  { id: "pearl", label: "Pearl Bracelets" },
  { id: "festive", label: "Festive Bracelets" },
  { id: "evil-eye", label: "Evil Eye Bracelets" },
  { id: "floral", label: "Floral Bracelets" },
  { id: "heart-love", label: "Heart & Love Bracelets" },
  { id: "premium", label: "Premium Signature Bracelets" },
];

export const CATEGORY_LABEL = Object.fromEntries(CATEGORIES.map((c) => [c.id, c.label]));

export const COLLECTION_COPY = {
  everyday: { title: "Everyday", tagline: "For your daily shine." },
  minimal: { title: "Minimal", tagline: "Less, but forever." },
  charm: { title: "Charm", tagline: "Little stories, beautifully told." },
  statement: { title: "Statement", tagline: "Designed to be remembered." },
  tennis: { title: "Tennis", tagline: "A line of light, always." },
  pearl: { title: "Pearl", tagline: "Soft elegance, always." },
  festive: { title: "Festive", tagline: "For life's brighter moments." },
  "evil-eye": { title: "Evil Eye", tagline: "A quiet guard, beautifully worn." },
  floral: { title: "Floral", tagline: "In full bloom, every day." },
  "heart-love": { title: "Heart & Love", tagline: "Worn close, meant closer." },
  premium: { title: "Premium Signature", tagline: "The finest of the house." },
};
